<template>
  <div class="col-xs-6 col-xs-offset-3 col-md-2 col-md-offset-5  form-group">
    <div class="share_btn share_btn_peachDefault">
      <a @click="update">立即啟動 Go</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "index_button",
  methods: {
    update() {
      this.$emit('update')
    },
  }
}
</script>